<template>
  <v-container
    v-if="quote"
  >
    <figure class="quote mb-9 mt-5">
      <blockquote class="blockquote">
        {{ quote.quote }}
      </blockquote>
      <figcaption v-if="quote.book">
        <router-link :to="{ name: 'book', params: { id: quote.book.id } }">{{ quote.book.title }} by <em>{{ quote.book.author}}</em></router-link>
        <small v-if="quote.page_number">, p.&nbsp;{{ quote.page_number }}</small>
      </figcaption>
    </figure>

    <template v-if="quote.tags.length > 0">
      <strong class="mr-5">Tags:</strong>
      <v-chip v-for="tag in quote.tags" :key="tag" :to="{ name: 'tag', params: { tag: tag } }" small pill dark class="mr-3">
        {{ tag }}
      </v-chip>
    </template>

    <v-toolbar class="mt-9">

      <v-dialog
        v-model="editDialog"
        max-width="500"
        >
        <template v-slot:activator="{ on }">
          <v-btn
          :disabled="deleting"
            v-on="on"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <v-card>
          <EditQuote
            :quote="quote"
            @submit="quoteChanged"
          />
        </v-card>
      </v-dialog>

      <v-spacer></v-spacer>

      <v-btn @click="shareQuote">
        <v-icon>mdi-share-variant</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <v-dialog
        v-model="deleteDialog"
        max-width="500"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            :loading="deleting"
            v-on="on"
          >
            <v-icon>mdi-delete-forever</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-card-title
            class="headline grey lighten-2"
            primary-title
          >
            Delete Quote
          </v-card-title>

          <p>
            Do you want to delete this quote?
          </p>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn
              @click="deleteDialog = false"
            >
              Cancel
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              @click="deleteQuote"
            >
              Delete Quote
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <v-snackbar
      v-model="snackbar"
      :timeout="3000"
    >
      Quote copied to clipboard!
    </v-snackbar>

  </v-container>
</template>

<script>
import EditQuote from '../components/EditQuote.vue'

export default {
  name: 'Quote',
  components: {
    EditQuote
  },
  data () {
    return {
      editDialog: false,
      deleteDialog: false,
      deleting: false,
      snackbar: false
    }
  },
  mounted () {
    this.$emit('updatenav', -1)
  },
  computed: {
    quote () {
      const qid = this.$route.params.id
      const q = this.$store.getters.getQuoteById(qid)
      if (q === undefined) {
        if (qid[0] === '@') {
          const newId = this.$store.getters.getQuoteIdByOldId(qid)
          if (newId !== undefined) {
            this.$router.replace({ name: 'quote', params: { id: newId } })
            return this.$store.getters.getQuoteById(newId)
          }
        }
      }
      return q
    }
  },
  methods: {
    quoteChanged (saveQuote) {
      this.editDialog = false
      saveQuote.catch(() => {
        this.editDialog = true
      })
    },
    deleteQuote () {
      this.deleting = true
      this.deleteDialog = false
      this.$store.dispatch('deleteQuote', this.quote).then(() => {
        this.$router.push({ name: 'home' })
      })
    },
    shareQuote () {
      if (navigator.share) {
        let title = []
        if (this.quote.book) {
          title.push(this.quote.book.title)
          if (this.quote.book.author) {
            title.push(`by ${this.quote.book.author}`)
          }
        }
        if (this.quote.page_number) {
          title.push(`p. ${this.quote.page_number}`)
        }
        const shareData = {
          title: title.join(' '),
          text: this.quote.quote
        }
        navigator.share(shareData)
      } else {
        navigator.clipboard.writeText(this.quote.quote)
        this.snackbar = true
      }
    }
  }
}
</script>

<style scoped>
  .quote {
    margin: 0 auto;
    max-width: 450px;
    color: #333;
    background-color: #fff;
  }
  .quote figcaption {
    padding: 1rem;
    text-align: right;
  }
  blockquote.blockquote {
    font-family: Georgia;
    padding: 1rem;
    line-height: 1.7em;
  }
</style>
